import * as lib from '~/dependencies';

export const Container = lib.styled.div`
  display: flex;
  flex: 1;
  flex-direction: row;
  max-height: 45px;
  gap: 8px;

  .icon-contact { 
    display: flex;
    align-items: center;

    svg {
      width: 25px;

      path {
          fill: #3699ff !important;
        }
    }
  }

  .icon-download {
    display: flex;
    align-items: center;

    svg {
      width: 20px;
    }
  }

`;

export const ContactInfo = lib.styled.div`
  display: flex;
  flex-direction: column;
  flex: 2;
  align-items: flex-start;
  margin-left: 3px;
  opacity: 0.8;
`;

export const Name = lib.styled.span`
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  max-width: 18ch;
  font-weight: 600;
  font-size: 14px;
  color: #4c595f;
`;

export const Number = lib.styled.span`
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  max-width: 30ch;
  font-size: 10px;
  color: #555;
`;
